const permissionConfig = [
  {
    role: "Admin",
    show: [
      "Dashboard",
      "Settings",
      "Services",
      "Booking Categories",
      "Care Reasons",
      "Work List",
      "My Work List",
      "Languages",
      "Location",
      "Preferred Time",
      "Urgencies",
      "Lead Status",
      "Available-Shifts",
      "Days-Available",
      "Education-Levels",
      "Hospital-Facilities",
      "Carepreneur",
      "Facility-Service",
      "Interaction",
      "States",
      "Districts",
      "Cities",
      "Co-Ordinators",
      "Managers",
      "Lead-Source",
      "Interaction-Type",
      "Interaction-Channel",
      "Interaction-Outcome",
      "FollowUpMode",
      "ResourceType",
      "AssessmentType",
      "AssessmentMode",
      "RiskCategory",
      "ResourceCategory",
      "Relations",
      "Tariffs",
      "Carepreneur",
      "Hospital",
      "Marketing",
      "Blog Categories",
      "Blog Posts",
      "Contacts",
      "Seo-Url",
      "Medical Equipments",
      "Systematic Categories",
      "Systematic Status",
      "Risk Categories",
      "Risk Levels",
      "ADL Categories",
      "ADL Choices",
      "Vital Categories",
      "Vital Choices",
      "Comorbidity Master",
      "Skill Level Master",
      "Medication Complexities",
      "Home Readiness",
      "Scenario Categories",
      "Scenario Choices",
      "Physiotherapy Types",
      "Nursing Procedures",
      "Clinical Stability Masters",
      "Frequency Masters",
      "Speciality Master",
    ],
  },
  {
    role: "lead_coordinator",
    show: ["Dashboard", "Work List", "My Work List", "Interaction"],
  },
  {
    role: "hospital",
    show: ["Profile", "Work List"],
  },
  {
    role: "carepreneur",
    show: ["Work List", "Carepreneur"],
  },
  {
    role: "CareLeader",
    show: ["Dashboard", "Work List", "My Work List"],
  }
];

export default permissionConfig;
